import { CameraIcon } from '@phosphor-icons/react';
import { T, useGT } from 'gt-react';
import { Button } from 'src/components/ui/button';
import type { Span } from './types';

/** Hosts with a screen panel can reveal a frame without opening the span inspector. */
export function SpanScreenshotButton({
  span,
  onSelect,
}: {
  span: Span;
  onSelect?: (span: Span) => void;
}) {
  const gt = useGT();
  if (!onSelect) {
    return (
      <CameraIcon
        aria-hidden
        className="size-3 shrink-0 text-muted-foreground"
      />
    );
  }
  return (
    <Button
      variant="ghost"
      size="sm"
      aria-label={gt('View Screenshot for {name}', {
        context: 'open a trace action screenshot in the run screen panel',
        name: span.name,
      })}
      onClick={(event) => {
        event.stopPropagation();
        onSelect(span);
      }}
      onKeyDown={(event) => event.stopPropagation()}
    >
      <CameraIcon aria-hidden />
      <T context="trace action button to open its captured screen">
        Screenshot
      </T>
    </Button>
  );
}
